/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Maintenance Monitor API
 * API for supporting Maintenance Monitor application
 * OpenAPI spec version: 1.0.0-Draft
 */
import * as zod from 'zod';


/**
 * Query for leads
 */
export const findLeadsQueryDealerIdItemMin = 9;
export const findLeadsQueryDealerIdItemMax = 9;

export const findLeadsQueryDealerIdMax = 300;



export const FindLeadsQueryParams = zod.object({
  "dealerId": zod.array(zod.string().min(findLeadsQueryDealerIdItemMin).max(findLeadsQueryDealerIdItemMax).describe('Id of the home dealership for this truck')).min(1).max(findLeadsQueryDealerIdMax).optional().describe('The ids of the home dealerships. If omitted, the results are not filtered by dealer.')
})

export const findLeadsResponseVinMin = 17;
export const findLeadsResponseVinMax = 17;

export const findLeadsResponseVehicleVinMin = 17;
export const findLeadsResponseVehicleVinMax = 17;

export const findLeadsResponseVehicleOdometerValueMin = 0;
export const findLeadsResponseVehicleOdometerValueMax = 2000000;

export const findLeadsResponseHomeDealerIdMin = 9;
export const findLeadsResponseHomeDealerIdMax = 9;

export const findLeadsResponseHomeDealerNameMin = 3;
export const findLeadsResponseHomeDealerNameMax = 64;

export const findLeadsResponseHomeDealerGroupNameMax = 200;

export const findLeadsResponseHomeDealerCityMax = 200;

export const findLeadsResponseHomeDealerStateRegExp = new RegExp('^[A-Z]{2}$');
export const findLeadsResponseHomeDealerLocationCodeRegExp = new RegExp('^[0-9]{3}$');
export const findLeadsResponseOdometerValueMin = 0;
export const findLeadsResponseOdometerValueMax = 2000000;

export const findLeadsResponseCustomerIdMin = 3;
export const findLeadsResponseCustomerIdMax = 64;

export const findLeadsResponseCustomerNameMin = 2;
export const findLeadsResponseCustomerNameMax = 128;

export const findLeadsResponseCustomerContactNameMin = 2;
export const findLeadsResponseCustomerContactNameMax = 128;

export const findLeadsResponseCustomerContactPhoneRegExp = new RegExp('^\\+?[0-9]{3,15}$');
export const findLeadsResponseMaintenanceSellingDealerIdIdMin = 9;
export const findLeadsResponseMaintenanceSellingDealerIdIdMax = 9;

export const findLeadsResponseMaintenanceSellingDealerIdNameMin = 3;
export const findLeadsResponseMaintenanceSellingDealerIdNameMax = 64;

export const findLeadsResponseMaintenanceSellingDealerIdGroupNameMax = 200;

export const findLeadsResponseMaintenanceSellingDealerIdCityMax = 200;

export const findLeadsResponseMaintenanceSellingDealerIdStateRegExp = new RegExp('^[A-Z]{2}$');
export const findLeadsResponseMaintenanceSellingDealerIdLocationCodeRegExp = new RegExp('^[0-9]{3}$');
export const findLeadsResponseMaintenanceDueMileageValueMin = 0;
export const findLeadsResponseMaintenanceDueMileageValueMax = 2000000;

export const findLeadsResponseMaintenanceMaintenanceItemsItemDescriptionMin = 3;
export const findLeadsResponseMaintenanceMaintenanceItemsItemDescriptionMax = 128;

export const findLeadsResponseMaintenanceMaintenanceItemsItemVmrsCodeMin = 11;
export const findLeadsResponseMaintenanceMaintenanceItemsItemVmrsCodeMax = 11;


export const findLeadsResponseMaintenanceMaintenanceItemsItemVmrsCodeRegExp = new RegExp('^[0-9]{3}-[0-9]{3}-[0-9A-Z]{3}$');
export const findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemNumberMin = 5;
export const findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemNumberMax = 32;

export const findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemQuantityValueMin = 0;
export const findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemQuantityValueMax = 10000;
export const findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemQuantityValueMultipleOf = 0.1;

export const findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemDescriptionMin = 3;
export const findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemDescriptionMax = 128;

export const findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemCodeMin = 3;
export const findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemCodeMax = 32;

export const findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemDescriptionMin = 3;
export const findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemDescriptionMax = 128;

export const findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemHoursMin = 0;
export const findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemHoursMax = 1000;
export const findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemHoursMultipleOf = 0.1;




export const FindLeadsResponseItem = zod.object({
  "id": zod.uuid().describe('Id of the lead'),
  "vin": zod.string().min(findLeadsResponseVinMin).max(findLeadsResponseVinMax).describe('Vehicle Identification Number'),
  "vehicle": zod.object({
  "vin": zod.string().min(findLeadsResponseVehicleVinMin).max(findLeadsResponseVehicleVinMax).describe('Vehicle Identification Number'),
  "odometer": zod.object({
  "value": zod.number().min(findLeadsResponseVehicleOdometerValueMin).max(findLeadsResponseVehicleOdometerValueMax),
  "unit": zod.enum(['mi', 'km'])
}).nullish()
}),
  "homeDealer": zod.object({
  "id": zod.string().min(findLeadsResponseHomeDealerIdMin).max(findLeadsResponseHomeDealerIdMax).describe('Id of the home dealership for this truck'),
  "name": zod.string().min(findLeadsResponseHomeDealerNameMin).max(findLeadsResponseHomeDealerNameMax).describe('Name of dealership'),
  "groupName": zod.string().min(1).max(findLeadsResponseHomeDealerGroupNameMax).nullish().describe('Group name of dealership'),
  "city": zod.string().min(1).max(findLeadsResponseHomeDealerCityMax).describe('City of dealership'),
  "state": zod.string().regex(findLeadsResponseHomeDealerStateRegExp).describe('State of dealership'),
  "locationCode": zod.string().regex(findLeadsResponseHomeDealerLocationCodeRegExp).describe('Location code of dealership')
}).nullable(),
  "odometer": zod.object({
  "value": zod.number().min(findLeadsResponseOdometerValueMin).max(findLeadsResponseOdometerValueMax),
  "unit": zod.enum(['mi', 'km'])
}).nullish(),
  "customer": zod.object({
  "id": zod.string().min(findLeadsResponseCustomerIdMin).max(findLeadsResponseCustomerIdMax).describe('Id of the customer'),
  "name": zod.string().min(findLeadsResponseCustomerNameMin).max(findLeadsResponseCustomerNameMax).describe('Customer name'),
  "contactName": zod.string().min(findLeadsResponseCustomerContactNameMin).max(findLeadsResponseCustomerContactNameMax).nullable().describe('Customer contact person name'),
  "contactPhone": zod.string().regex(findLeadsResponseCustomerContactPhoneRegExp).nullable()
}).nullable(),
  "workflow": zod.object({
  "createdAt": zod.iso.datetime({"offset":true}).describe('Time when lead was created.'),
  "scheduledDate": zod.iso.datetime({"offset":true}).nullable().describe('Date when maintenance is scheduled.'),
  "customerUnreachableAt": zod.iso.datetime({"offset":true}).nullable().describe('Time when customer was marked unreachable.'),
  "technicianAssignedAt": zod.iso.datetime({"offset":true}).nullable().describe('Time when technician was assigned.'),
  "partsReadyAt": zod.iso.datetime({"offset":true}).nullable().describe('Time when parts were ready.'),
  "workStartedAt": zod.iso.datetime({"offset":true}).nullable().describe('Time when work started.'),
  "workFinishedAt": zod.iso.datetime({"offset":true}).nullable().describe('Time when work finished.'),
  "claimSubmittedAt": zod.iso.datetime({"offset":true}).nullable().describe('Time when claim was submitted.'),
  "claimApprovedAt": zod.iso.datetime({"offset":true}).nullable().describe('Time when claim was approved.'),
  "noShowAt": zod.iso.datetime({"offset":true}).nullable().describe('Time when lead was marked as no-show.'),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable().describe('Time when lead was archived.')
}),
  "maintenance": zod.object({
  "dueDate": zod.iso.date().describe('Due date for maintenance. Minimum allowed value is 2024-01-01. Maximum allowed value is 2099-01-01.'),
  "sellingDealerId": zod.object({
  "id": zod.string().min(findLeadsResponseMaintenanceSellingDealerIdIdMin).max(findLeadsResponseMaintenanceSellingDealerIdIdMax).describe('Id of the home dealership for this truck'),
  "name": zod.string().min(findLeadsResponseMaintenanceSellingDealerIdNameMin).max(findLeadsResponseMaintenanceSellingDealerIdNameMax).describe('Name of dealership'),
  "groupName": zod.string().min(1).max(findLeadsResponseMaintenanceSellingDealerIdGroupNameMax).nullish().describe('Group name of dealership'),
  "city": zod.string().min(1).max(findLeadsResponseMaintenanceSellingDealerIdCityMax).describe('City of dealership'),
  "state": zod.string().regex(findLeadsResponseMaintenanceSellingDealerIdStateRegExp).describe('State of dealership'),
  "locationCode": zod.string().regex(findLeadsResponseMaintenanceSellingDealerIdLocationCodeRegExp).describe('Location code of dealership')
}),
  "dueMileage": zod.object({
  "value": zod.number().min(findLeadsResponseMaintenanceDueMileageValueMin).max(findLeadsResponseMaintenanceDueMileageValueMax),
  "unit": zod.enum(['mi', 'km'])
}).nullable(),
  "maintenanceItems": zod.array(zod.object({
  "description": zod.string().min(findLeadsResponseMaintenanceMaintenanceItemsItemDescriptionMin).max(findLeadsResponseMaintenanceMaintenanceItemsItemDescriptionMax),
  "vmrsCode": zod.string().min(findLeadsResponseMaintenanceMaintenanceItemsItemVmrsCodeMin).max(findLeadsResponseMaintenanceMaintenanceItemsItemVmrsCodeMax).regex(findLeadsResponseMaintenanceMaintenanceItemsItemVmrsCodeRegExp).describe('Vehicle Maintenance Reporting Standards code'),
  "parts": zod.array(zod.object({
  "number": zod.string().min(findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemNumberMin).max(findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemNumberMax).describe('Part number'),
  "quantity": zod.object({
  "value": zod.number().min(findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemQuantityValueMin).max(findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemQuantityValueMax).multipleOf(findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemQuantityValueMultipleOf).describe('The quantity of the part in decimal format.'),
  "unit": zod.enum(['Each', 'Gallon', 'Liter', 'Quart', 'Pint', 'Pound', 'Kilogram']).describe('Unit of measure for the quantity (e.g., Each, Quart, Gallon, Liter)')
}),
  "description": zod.string().min(findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemDescriptionMin).max(findLeadsResponseMaintenanceMaintenanceItemsItemPartsItemDescriptionMax)
})),
  "srts": zod.array(zod.object({
  "code": zod.string().min(findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemCodeMin).max(findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemCodeMax).describe('Standard Repair Time code'),
  "description": zod.string().min(findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemDescriptionMin).max(findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemDescriptionMax),
  "hours": zod.number().min(findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemHoursMin).max(findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemHoursMax).multipleOf(findLeadsResponseMaintenanceMaintenanceItemsItemSrtsItemHoursMultipleOf).describe('Standard labor hours in decimal format.')
})).min(1)
}))
})
})
export const FindLeadsResponse = zod.array(FindLeadsResponseItem)

/**
 * Update workflow for a lead
 */
export const PatchWorkflowParams = zod.object({
  "leadId": zod.uuid().describe('The id of the lead')
})

export const PatchWorkflowBody = zod.object({
  "scheduledDate": zod.iso.datetime({"offset":true}).nullish().describe('Date when maintenance is scheduled.'),
  "customerUnreachableAt": zod.iso.datetime({"offset":true}).nullish().describe('Time when customer was marked unreachable.'),
  "technicianAssignedAt": zod.iso.datetime({"offset":true}).nullish().describe('Time when technician was assigned.'),
  "partsReadyAt": zod.iso.datetime({"offset":true}).nullish().describe('Time when parts were ready.'),
  "workStartedAt": zod.iso.datetime({"offset":true}).nullish().describe('Time when work started.'),
  "workFinishedAt": zod.iso.datetime({"offset":true}).nullish().describe('Time when work finished.'),
  "claimSubmittedAt": zod.iso.datetime({"offset":true}).nullish().describe('Time when claim was submitted.'),
  "claimApprovedAt": zod.iso.datetime({"offset":true}).nullish().describe('Time when claim was approved.'),
  "noShowAt": zod.iso.datetime({"offset":true}).nullish().describe('Time when lead was marked as no-show.'),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish().describe('Time when lead was archived.')
})

/**
 * patches a lead
 */
export const PatchLeadParams = zod.object({
  "leadId": zod.uuid().describe('The id of the lead')
})

export const patchLeadBodyOdometerValueMin = 0;
export const patchLeadBodyOdometerValueMax = 2000000;



export const PatchLeadBody = zod.object({
  "odometer": zod.object({
  "value": zod.number().min(patchLeadBodyOdometerValueMin).max(patchLeadBodyOdometerValueMax),
  "unit": zod.enum(['mi', 'km'])
}).nullish()
})

/**
 * Get all notes for a lead, including history
 */
export const FindNotesParams = zod.object({
  "leadId": zod.uuid().describe('The id of the lead')
})

export const FindNotesResponseItem = zod.object({
  "id": zod.uuid().describe('Unique identifier of the note (mapped to Message ID)'),
  "content": zod.string().describe('Note content'),
  "createdAt": zod.iso.datetime({"offset":true}).describe('When the note was created'),
  "createdBy": zod.object({
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "email": zod.string()
}).optional()
})
export const FindNotesResponse = zod.array(FindNotesResponseItem)

/**
 * Create a new note for a lead
 */
export const CreateNoteParams = zod.object({
  "leadId": zod.uuid().describe('The id of the lead')
})

export const createNoteBodyContentMax = 4096;



export const CreateNoteBody = zod.object({
  "content": zod.string().min(1).max(createNoteBodyContentMax).describe('Note content')
})

